import { render, staticRenderFns } from "./EpotGreeting.vue?vue&type=template&id=ac974672&"
import script from "./EpotGreeting.vue?vue&type=script&lang=js&"
export * from "./EpotGreeting.vue?vue&type=script&lang=js&"
import style0 from "./EpotGreeting.vue?vue&type=style&index=0&id=ac974672&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports